import { AddCircleOutline, GetAppOutlined, UpgradeOutlined } from '@mui/icons-material';
import { Button, Stack } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

export interface ManufacturersListMenuButtonsProps {
    handleAdd: () => void;
    handleImport: () => void;
    handleTemplate: () => void;
}

export default function ManufacturersListMenuButtons(props: Readonly<ManufacturersListMenuButtonsProps>) {
    const { handleAdd, handleImport, handleTemplate } = props;
    const { t } = useTranslation();

    return (
        <Stack spacing={2} direction={'row'} mr={2}>
            <Button onClick={handleAdd} startIcon={<AddCircleOutline />} variant='contained' size='small'>{t('Add')}</Button>
            <Button onClick={handleImport} startIcon={<GetAppOutlined />} variant='contained' size='small'>{t('warehouses.importXLS')}</Button>
            <Button onClick={handleTemplate} startIcon={<UpgradeOutlined />} variant='contained' size='small'>{t('warehouses.exportTemplateXLS')}</Button>
        </Stack>
    );
}
